<script setup lang="ts">
import UserMenu from './UserMenu.vue';

const links = [
  { to: '/', label: 'Dashboard' },
  { to: '/usernames', label: 'Usernames' },
  { to: '/compose', label: 'Compose' },
  { to: '/blacklist', label: 'Blacklist' },
  { to: '/logs', label: 'Logs' },
  { to: '/settings', label: 'Settings' },
];
</script>

<template>
  <header class="header">
    <div class="inner">
      <RouterLink to="/" class="brand">
        <img src="/favicon-192.png" alt="" width="24" height="24" />
        <span>Email Masking</span>
      </RouterLink>
      <nav>
        <RouterLink v-for="link in links" :key="link.to" :to="link.to" class="nav-link">{{ link.label }}</RouterLink>
      </nav>
      <UserMenu />
    </div>
  </header>
</template>

<style scoped>
.header { background: var(--surface); border-bottom: 1px solid var(--border); position: sticky; top: 0; z-index: 10; }
.inner { max-width: 1180px; margin: 0 auto; padding: 0 16px; display: flex; align-items: center; gap: 24px; min-height: 56px; flex-wrap: wrap; }
.brand { display: flex; align-items: center; gap: 8px; font-weight: 700; color: var(--text); text-decoration: none; }
nav { display: flex; gap: 4px; flex: 1; overflow-x: auto; }
.nav-link { color: var(--muted); text-decoration: none; padding: 6px 10px; border-radius: 8px; font-weight: 500; white-space: nowrap; }
.nav-link:hover { color: var(--text); background: var(--surface-2); }
.nav-link.router-link-exact-active { color: var(--primary); background: var(--primary-soft); }
@media (max-width: 640px) {
  .inner { gap: 8px; padding-top: 8px; }
  nav { order: 3; flex-basis: 100%; padding-bottom: 8px; }
}
</style>
